/**
 * BOC MONG QUANH @pdf-lib/fontkit.
 *
 * Vi sao la @pdf-lib/fontkit chu khong phai fontkit goc: ban goc huong Node
 * (dung fs, Buffer, brotli native) va khong dong goi sach cho trinh duyet.
 * Ban cua pdf-lib la ban rollup san cho trinh duyet VA chinh la ban ma
 * PDFDocument.registerFontkit() cho.
 *
 * Mot ban duy nhat duoc dung cho ca hai viec - do glyph va tao subset - de
 * khong bao gio xay ra chuyen "font do duoc bang thu vien A nhung thu vien B
 * tu choi nhung no".
 */
import fontkitDefault from '@pdf-lib/fontkit';
import type { Font } from '@pdf-lib/fontkit';

export type { Font };

/**
 * Doi tuong fontkit tho. Truyen thang cho PDFDocument.registerFontkit().
 * pdf-lib khai bao tham so nay bang kieu Fontkit rieng cua no nen phai ep kieu
 * o dung mot cho - day.
 */
export const rawFontkit: unknown = fontkitDefault;

interface FontkitModule {
  create(bytes: Uint8Array, postscriptName?: string): Font;
}

const fk = fontkitDefault as unknown as FontkitModule;

/** Mot tap hop font (.ttc) lo ra mang `fonts`; mot font don thi khong. */
interface MaybeCollection {
  fonts?: Font[];
}

/**
 * Doc byte font thanh doi tuong fontkit. Tra ve null khi khong doc duoc -
 * ben goi PHAI coi day la "khong dung duoc font nay", khong duoc coi la dat.
 */
export function fontFromBytes(bytes: Uint8Array | null | undefined): Font | null {
  if (!bytes || bytes.length === 0) return null;
  try {
    const created = fk.create(bytes) as Font & MaybeCollection;
    if (Array.isArray(created.fonts)) return created.fonts[0] ?? null;
    return created;
  } catch {
    return null;
  }
}
